import React from 'react';
import { Link } from 'react-router-dom';
import { DropletIcon, FlameIcon, ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
const Home = () => {
  return <div className="w-full" data-id="element-565">
      {/* Hero Section */}
      <section className="min-h-screen flex flex-col justify-center items-center text-center px-4 pt-24 pb-16" data-id="element-566">
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-4" data-id="element-567">
          Spora: Beyond Coffee. Beyond Tea.
        </h1>
        <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-568">
          The Third Liquid Culture™
        </p>
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-569">
          <Link to="/cordyceps" className="bg-black text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors" data-id="element-570">
            Explore the Six
          </Link>
          <Link to="/how-it-works" className="bg-white text-black border border-black px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-571">
            How It Works
          </Link>
          <Link to="#" className="bg-red-500 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-red-600 transition-colors" data-id="element-572">
            Get Spora
          </Link>
        </div>
      </section>
      {/* Spectrum Strip */}
      <section className="py-16 px-4" data-id="element-573">
        <h2 className="text-3xl font-bold text-center mb-12" data-id="element-574">The Spectrum™</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-575">
          {/* Energy - Cordyceps */}
          <Link to="/cordyceps" className="group" data-id="element-576">
            <div className="bg-gradient-to-b from-red-50 to-red-100 rounded-2xl p-6 h-full transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-577">
              <div className="w-16 h-1 bg-red-500 mb-6 rounded-full" data-id="element-578"></div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-579">Energy</h3>
              <p className="text-lg font-medium text-red-600 mb-4" data-id="element-580">Cordyceps</p>
              <p className="text-gray-600" data-id="element-581">
                Non-caffeinated stamina. Bright botanical finish.
              </p>
            </div>
          </Link>
          {/* Health - Turkey Tail */}
          <Link to="/turkey-tail" className="group" data-id="element-582">
            <div className="bg-gradient-to-b from-orange-50 to-orange-100 rounded-2xl p-6 h-full transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-583">
              <div className="w-16 h-1 bg-orange-500 mb-6 rounded-full" data-id="element-584"></div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-585">Health</h3>
              <p className="text-lg font-medium text-orange-600 mb-4" data-id="element-586">
                Turkey Tail
              </p>
              <p className="text-gray-600" data-id="element-587">
                Immune support with a light, refreshing taste.
              </p>
            </div>
          </Link>
          {/* Intelligence - Lion's Mane */}
          <Link to="/lions-mane" className="group" data-id="element-588">
            <div className="bg-gradient-to-b from-yellow-50 to-yellow-100 rounded-2xl p-6 h-full transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-589">
              <div className="w-16 h-1 bg-yellow-500 mb-6 rounded-full" data-id="element-590"></div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-591">Intelligence</h3>
              <p className="text-lg font-medium text-yellow-600 mb-4" data-id="element-592">
                Lion's Mane
              </p>
              <p className="text-gray-600" data-id="element-593">
                Mental clarity with a clean, crisp undertone.
              </p>
            </div>
          </Link>
          {/* Peace - Reishi */}
          <Link to="/reishi" className="group" data-id="element-594">
            <div className="bg-gradient-to-b from-green-50 to-green-100 rounded-2xl p-6 h-full transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-595">
              <div className="w-16 h-1 bg-green-500 mb-6 rounded-full" data-id="element-596"></div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-597">Peace</h3>
              <p className="text-lg font-medium text-green-600 mb-4" data-id="element-598">Reishi</p>
              <p className="text-gray-600" data-id="element-599">Calm focus with smoky notes.</p>
            </div>
          </Link>
          {/* Endurance - Chaga */}
          <Link to="/chaga" className="group" data-id="element-600">
            <div className="bg-gradient-to-b from-blue-50 to-blue-100 rounded-2xl p-6 h-full transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-601">
              <div className="w-16 h-1 bg-blue-500 mb-6 rounded-full" data-id="element-602"></div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-603">Endurance</h3>
              <p className="text-lg font-medium text-blue-600 mb-4" data-id="element-604">Chaga</p>
              <p className="text-gray-600" data-id="element-605">
                Sustained vitality with sweet warmth.
              </p>
            </div>
          </Link>
          {/* Resilience - Shiitake */}
          <Link to="/shiitake" className="group" data-id="element-606">
            <div className="bg-gradient-to-b from-purple-50 to-purple-100 rounded-2xl p-6 h-full transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-607">
              <div className="w-16 h-1 bg-purple-500 mb-6 rounded-full" data-id="element-608"></div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-609">Resilience</h3>
              <p className="text-lg font-medium text-purple-600 mb-4" data-id="element-610">
                Shiitake
              </p>
              <p className="text-gray-600" data-id="element-611">
                Adaptogenic balance with dark richness.
              </p>
            </div>
          </Link>
        </div>
      </section>
      {/* The Ritual */}
      <section className="py-16 px-4 bg-white" data-id="element-612">
        <div className="max-w-7xl mx-auto" data-id="element-613">
          <h2 className="text-3xl font-bold text-center mb-6" data-id="element-614">The Ritual</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto text-center mb-12" data-id="element-615">
            Every cup of Spora is unlocked by a three-part ceremony. Each step
            is built into our jars — so you don't have to think, only sip.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-616">
            <div className="flex flex-col items-center text-center" data-id="element-617">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-50 rounded-full shadow-sm mb-6" data-id="element-618">
                <DropletIcon className="w-8 h-8" data-id="element-619" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-620">Pre-Soak</h3>
              <p className="text-gray-600" data-id="element-621">
                The ancient spirits awaken compounds insoluble in water alone,
                beginning the alchemical transformation.
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-622">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-50 rounded-full shadow-sm mb-6" data-id="element-623">
                <FlameIcon className="w-8 h-8" data-id="element-624" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-625">Infuse</h3>
              <p className="text-gray-600" data-id="element-626">
                Heat unlocks the cell walls, releasing the full spectrum of
                bioactive compounds while ethanol transforms.
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-627">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-50 rounded-full shadow-sm mb-6" data-id="element-628">
                <div className="w-8 h-8" data-id="element-629" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-630">Press</h3>
              <p className="text-gray-600" data-id="element-631">
                The final expression releases the complete essence, creating a
                balanced elixir of flavor and function.
              </p>
            </div>
          </div>
          <div className="text-center mt-10" data-id="element-632">
            <Link to="/how-it-works" className="inline-flex items-center text-gray-800 font-medium hover:text-black" data-id="element-633">
              <span data-id="element-634">How it works</span>
              <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-635" />
            </Link>
          </div>
        </div>
      </section>
      {/* Comparison Section */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-636">
        <div className="max-w-5xl mx-auto" data-id="element-637">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-638">
            The Third Liquid Culture™
          </h2>
          <div className="overflow-x-auto" data-id="element-639">
            <table className="w-full min-w-[600px] bg-white rounded-xl shadow-sm" data-id="element-640">
              <thead data-id="element-641">
                <tr data-id="element-642">
                  <th className="text-left p-4 border-b border-gray-100" data-id="element-643"></th>
                  <th className="text-center p-4 border-b border-gray-100 font-bold" data-id="element-644">
                    Spora
                  </th>
                  <th className="text-center p-4 border-b border-gray-100 font-bold" data-id="element-645">
                    Coffee
                  </th>
                  <th className="text-center p-4 border-b border-gray-100 font-bold" data-id="element-646">
                    Tea
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-647">
                <tr data-id="element-648">
                  <td className="p-4 border-b border-gray-100 font-medium" data-id="element-649">
                    Energy Effect
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-650">
                    <span className="flex items-center justify-center" data-id="element-651">
                      <CheckIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-652" />
                      Sustained, No Crash
                    </span>
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-653">
                    <span className="flex items-center justify-center" data-id="element-654">
                      <XIcon className="w-5 h-5 text-red-500 mr-1" data-id="element-655" />
                      Spike & Crash
                    </span>
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-656">
                    <span className="flex items-center justify-center" data-id="element-657">
                      <CheckIcon className="w-5 h-5 text-yellow-500 mr-1" data-id="element-658" />
                      Mild, Short-lived
                    </span>
                  </td>
                </tr>
                <tr data-id="element-659">
                  <td className="p-4 border-b border-gray-100 font-medium" data-id="element-660">
                    Unique Compounds
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-661">
                    <span className="flex items-center justify-center" data-id="element-662">
                      <CheckIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-663" />
                      β-glucans, Triterpenes
                    </span>
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-664">
                    <span className="flex items-center justify-center" data-id="element-665">
                      <CheckIcon className="w-5 h-5 text-yellow-500 mr-1" data-id="element-666" />
                      Caffeine, Antioxidants
                    </span>
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-667">
                    <span className="flex items-center justify-center" data-id="element-668">
                      <CheckIcon className="w-5 h-5 text-yellow-500 mr-1" data-id="element-669" />
                      Catechins, L-theanine
                    </span>
                  </td>
                </tr>
                <tr data-id="element-670">
                  <td className="p-4 border-b border-gray-100 font-medium" data-id="element-671">
                    Dependency Risk
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-672">
                    <span className="flex items-center justify-center" data-id="element-673">
                      <CheckIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-674" />
                      None
                    </span>
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-675">
                    <span className="flex items-center justify-center" data-id="element-676">
                      <XIcon className="w-5 h-5 text-red-500 mr-1" data-id="element-677" />
                      High
                    </span>
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center" data-id="element-678">
                    <span className="flex items-center justify-center" data-id="element-679">
                      <CheckIcon className="w-5 h-5 text-yellow-500 mr-1" data-id="element-680" />
                      Low
                    </span>
                  </td>
                </tr>
                <tr data-id="element-681">
                  <td className="p-4 font-medium" data-id="element-682">Sleep Impact</td>
                  <td className="p-4 text-center" data-id="element-683">
                    <span className="flex items-center justify-center" data-id="element-684">
                      <CheckIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-685" />
                      None
                    </span>
                  </td>
                  <td className="p-4 text-center" data-id="element-686">
                    <span className="flex items-center justify-center" data-id="element-687">
                      <XIcon className="w-5 h-5 text-red-500 mr-1" data-id="element-688" />
                      High
                    </span>
                  </td>
                  <td className="p-4 text-center" data-id="element-689">
                    <span className="flex items-center justify-center" data-id="element-690">
                      <CheckIcon className="w-5 h-5 text-yellow-500 mr-1" data-id="element-691" />
                      Low-Medium
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      {/* Why Spora */}
      <section className="py-16 px-4" data-id="element-692">
        <div className="max-w-7xl mx-auto" data-id="element-693">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-694">
            <div className="flex flex-col justify-center" data-id="element-695">
              <h2 className="text-3xl font-bold mb-6" data-id="element-696">Why Spora</h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-697">
                We've combined ancient wisdom with modern science to create a
                new category of functional beverages. Our dual-extraction method
                unlocks compounds no other food group can give you, maximizing
                bioavailability and effect.
              </p>
              <p className="text-lg text-gray-600" data-id="element-698">
                Each mushroom is carefully selected for its unique properties
                and paired with complementary spirits to enhance both flavor and
                function. The result is a category-defining experience that
                transforms wellness into ritual.
              </p>
              <div className="mt-8" data-id="element-699">
                <Link to="/faq" className="inline-flex items-center text-gray-800 font-medium hover:text-black" data-id="element-700">
                  <span data-id="element-701">FAQ</span>
                  <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-702" />
                </Link>
              </div>
            </div>
            <div className="bg-gray-100 rounded-2xl aspect-square" data-id="element-703"></div>
          </div>
        </div>
      </section>
      {/* Distributor CTA */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-704">
        <div className="max-w-3xl mx-auto text-center" data-id="element-705">
          <h2 className="text-3xl font-bold mb-6" data-id="element-706">
            Bring Spora to Your Customers
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-707">
            We're currently seeking strategic distribution partners to introduce
            The Third Liquid Culture™ to the market.
          </p>
          <Link to="/faq" className="bg-black text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors inline-block" data-id="element-708">
            Contact Us
          </Link>
        </div>
      </section>
      {/* Footer CTA */}
      <section className="py-16 px-4 bg-black text-white text-center" data-id="element-709">
        <h2 className="text-3xl font-bold mb-6" data-id="element-710">The Third Liquid Culture™</h2>
        <p className="text-xl max-w-2xl mx-auto mb-8" data-id="element-711">
          Mushrooms unlocked by spirit and heat — crafted like coffee, healthier
          than tea.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-712">
          <Link to="/cordyceps" className="bg-white text-black px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors" data-id="element-713">
            Explore the Six
          </Link>
          <Link to="/how-it-works" className="bg-transparent text-white border border-white px-8 py-3 rounded-full text-sm font-medium hover:bg-white/10 transition-colors" data-id="element-714">
            How It Works
          </Link>
          <Link to="#" className="bg-red-500 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-red-600 transition-colors" data-id="element-715">
            Get Spora
          </Link>
        </div>
      </section>
    </div>;
};
export default Home;